export enum DepthPackingStrategiesName {
  BasicDepthPacking = 'BasicDepthPacking',
  RGBADepthPacking = 'RGBADepthPacking'
}
